import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderItem } from '@app/core/services/transaction/model/order-item.model';

export interface OrderItemEntry {
  orderItem: OrderItem;
}

@Component({
    selector: 'ap-order-item-details-dialog',
    templateUrl: './order-item-details-dialog.component.html',
    styleUrls: ['./order-item-details-dialog.component.css'],
    standalone: false
})
export class OrderItemDetailsDialogComponent implements OnInit {

  orderItem: OrderItem;

  displayedColumns = ['TITLE', 'DESCRIPTION'];
  additionalInformationsArray: {name: string, value: string}[] = [];

  constructor(private dialogRef: MatDialogRef<OrderItemDetailsDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: OrderItemEntry) {
  }

  ngOnInit(): void {
    if (this.data.orderItem) {
      this.orderItem = this.data.orderItem;
    }

    if (this.orderItem && this.orderItem.additionalInformation) {
      if (!(this.orderItem.additionalInformation instanceof Map)) {
        this.orderItem.additionalInformation = new Map(Object.entries(this.orderItem.additionalInformation));
      }

      this.additionalInformationsArray = Array.from(this.orderItem.additionalInformation, ([name, value]) => ({ name: name, value: value }));
    }
  }

  closeModal() {
    this.dialogRef.close();
  }

}
